import DisplayOption from 'hb-builder/components/common/SettingsLibrary/CommonSettings/DisplayOption';
import TextSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/TextSetting';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';

const Headline = ({
  item,
  onChange,
}: Pick<ComponentSettingsTab, 'onChange' | 'item'>) => {
  const settingProps = { item, onChange };

  return (
    <>
      <DisplayOption {...settingProps} title={__('Display headline')} />
      <TextSetting
        {...settingProps}
        placeholder={__('Enter a headline')}
        settingKey="content"
        width="100%"
      />
    </>
  );
};

export default Headline;
